module.exports = __webpack_public_path__ + "static/media/logout.ef649c26.svg";